module Meevo.Components.Controls {
    "use strict";

    angular.module('meevo.components.controls').directive("meevoMaintenanceFormCentralOfficeSearchHeaderTemplate", function () {
        return {
            restrict: 'E',
            templateUrl: "app/components/controls/maintenanceFormCentralOfficeSearchHeaderTemplate.html"
        }
    });
}